import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompFluidLevels({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion');
  const [infoFluidsLevels, setInfoCompFluids] = useState({
    Engine_Oil: 'ALTO',
    Refrigerant: 'ALTO',
    Brake_fluid: 'ALTO',
    Hydraulic_steering: 'ALTO',
    windshield_wipers: 'ALTO',
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'FL', data: infoFluidsLevels });
  });

  const handleForm = ({ target }) => {
    const tmpFluidsLevels = {
      ...infoFluidsLevels,
      [target.name]: target.value,
    };
    setInfoCompFluids(tmpFluidsLevels);
    autosave.schedule();
    //generalUpdate('infoFluidsLevels', tmpFluidsLevels)
  };

  const getInfoState = async () => {
    setStates([
      {
        id: 'ALTO',
        name: 'ALTO',
      },
      {
        id: 'BAJO',
        name: 'BAJO',
      },
      {
        id: 'MUY BAJO',
        name: 'MUY BAJO',
      },
    ]);
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'FL', data: infoFluidsLevels };
    const respo = await post(
      '/peritaje/modifyinspection/components/' + id,
      body,
    );
    if (respo.success) {
      setMsgButton('Actualizar');
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'FL' };
      let tmpFluids = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        if (detail.length > 0) {
          for (let i = 0; i < detail.length; i++) {
            const element = detail[i];
            tmpFluids[element.name] = element.des_state;
          }
        } else {
          tmpFluids = {
            Engine_Oil: 'ALTO',
            Refrigerant: 'ALTO',
            Brake_fluid: 'ALTO',
            Hydraulic_steering: 'ALTO',
            windshield_wipers: 'ALTO',
          };
        }
        setInfoCompFluids(tmpFluids);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">NIVELES DE FLUIDOS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Engine_Oil">Aceite Motor</Form.Label>
          <Form.Select
            name="Engine_Oil"
            value={infoFluidsLevels.Engine_Oil}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Refrigerant">Refrigerante</Form.Label>
          <Form.Select
            name="Refrigerant"
            value={infoFluidsLevels.Refrigerant}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Brake_fluid">Liquido de frenos</Form.Label>
          <Form.Select
            name="Brake_fluid"
            value={infoFluidsLevels.Brake_fluid}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Hydraulic_steering">Direccion Hidraulica</Form.Label>
          <Form.Select
            name="Hydraulic_steering"
            value={infoFluidsLevels.Hydraulic_steering}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="windshield_wipers">Limpiabrisas</Form.Label>
          <Form.Select
            name="windshield_wipers"
            value={infoFluidsLevels.windshield_wipers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompFluidLevels;
